import React, { useEffect, useState } from "react";
import PriceSiteLayout from "./PriceSiteLayout";
import { api } from "@/lib/api";
import CguContent from "@/components/price/CguContent";

export default function PriceCGU() {
  useEffect(() => { document.title = "Conditions générales · Price Covoiturage"; }, []);
  const today = new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" });
  const [version, setVersion] = useState(undefined);
  useEffect(() => { api.get("/cgu/current").then(({ data }) => setVersion(data.version)).catch(() => setVersion(null)); }, []);
  if (version === undefined) return <PriceSiteLayout><main className="min-h-[60vh]" /></PriceSiteLayout>;
  if (version) {
    return (
      <PriceSiteLayout>
        <main className="mx-auto max-w-3xl px-5 py-14" data-testid="price-cgu-dynamic">
          <h1 className="font-[Outfit] text-4xl font-black leading-tight sm:text-5xl">Conditions générales d&apos;utilisation</h1>
          <p className="mt-3 text-sm" style={{ color: "rgba(30,9,16,0.6)" }} data-testid="price-cgu-version">
            Version {version.version} · en vigueur depuis le {new Date(version.published_at).toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" })}
          </p>
          <div className="mt-8 text-[15px]"><CguContent content={version.content} testid="price-cgu-content" /></div>
        </main>
      </PriceSiteLayout>
    );
  }
  return (
    <PriceSiteLayout>
      <main className="mx-auto max-w-3xl px-5 py-14">
        <h1 className="font-[Outfit] text-4xl font-black leading-tight sm:text-5xl">Conditions générales d&apos;utilisation</h1>
        <p className="mt-3 text-sm" style={{ color: "rgba(30,9,16,0.6)" }}>Dernière mise à jour : {today}</p>

        <div className="mt-10 max-w-none font-[Manrope] text-[15px] leading-relaxed" style={{ color: "rgba(30,9,16,0.85)" }}>
          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>1. Objet</h2>
          <p>Price est une plateforme de covoiturage mettant en relation des passagers avec des conducteurs partageant un trajet. Price n&apos;est pas un service de VTC ni de taxi.</p>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>2. Inscription</h2>
          <p>L&apos;inscription est gratuite et nécessite un email valide et un numéro de téléphone. L&apos;utilisateur s&apos;engage à fournir des informations exactes.</p>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>3. Rôles</h2>
          <ul className="mt-3 list-disc pl-6 space-y-1">
            <li><b>Passager</b> : publie une demande de trajet et paye sa part.</li>
            <li><b>Covoitureur</b> : propose un trajet ou accepte une demande live.</li>
          </ul>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>4. Prix &amp; paiement</h2>
          <p>Le prix est calculé en fonction du trajet et affiché avant confirmation. Le paiement se fait par carte via Stripe ou en espèces au covoitureur. Price perçoit une commission sur chaque trajet.</p>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>5. Annulation</h2>
          <p>Toute annulation doit intervenir avant le début effectif de la course. Une annulation tardive peut entraîner des frais.</p>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>6. Responsabilités</h2>
          <p>Price est un simple intermédiaire technique. Les utilisateurs sont responsables du respect du code de la route et des conditions de sécurité (permis, assurance, etc.).</p>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>7. Comportement</h2>
          <p>Tout comportement irrespectueux, discriminatoire ou dangereux peut entraîner la suspension immédiate du compte.</p>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>8. Résiliation</h2>
          <p>L&apos;utilisateur peut supprimer son compte à tout moment depuis l&apos;application (menu &gt; Supprimer mon compte).</p>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>9. Droit applicable</h2>
          <p>Les présentes CGU sont soumises au droit français. Tout litige sera porté devant les juridictions françaises compétentes.</p>
        </div>
      </main>
    </PriceSiteLayout>
  );
}
